import React from "react";
import { ShipmentProvider } from "../../contexts/ShipmentContext.jsx";
import ShipmentStatus from "./ShipmentStatus.jsx";
import ShipmentSummary from "./ShipmentSummary.jsx";
import ShipmentTimeline from "./ShipmentTimeline.jsx";
import ShipmentInfo from "./ShipmentInfo.jsx";
import ShipmentMap from "./ShipmentMap.jsx";
import ShipmentHistory from "./ShipmentHistory.jsx";
import ShipmentViewToggle from "./ShipmentViewToggle.jsx";

const ShipmentTracking = ({basePath, googleApiKey, trackingUrl}) => {

  const params = new URLSearchParams(window.location.search);
  const carrier = params.get("carrier");
  const proNumber = params.get("pro");
  const orderId = params.get("order");
  const loadId = params.get("load_id");
  const billingZip = params.get("billing_zip");

  const tracking_explanation = window.shipment_tracking.tracking_explanation;

  return (
    <ShipmentProvider carrier={carrier} proNumber={proNumber} googleApiKey={googleApiKey} trackingUrl={trackingUrl} orderId={orderId} loadId={loadId} billingZip={billingZip}>
      <ShipmentViewToggle>
        <ShipmentStatus />
        <ShipmentSummary />
        <ShipmentTimeline />
        <div className="container container--narrow shipment-tracking-explanation my-10 text-center text-lg" style="--container-max-width: 760px"  dangerouslySetInnerHTML={{
            __html: tracking_explanation,
            }}
          />
        <ShipmentMap />
        <ShipmentInfo />
        <ShipmentHistory />
      </ShipmentViewToggle>
    </ShipmentProvider>
  );

}

export default ShipmentTracking;
